import { UIProfileSettingsController } from '../../../../../../shared/scripts/profile/UIProfileSettingsController.ts';
import { showDeviceInfoDialog } from '../../../../../../shared/scripts/ui_popup/showDeviceInfoDialog.ts';
import { showPlayerEditProfileDialog } from '../../../../../../shared/scripts/ui_popup/edit_profile_dialog/showEditProfileDialog.ts';
import { ProfileEditAjaxEndPoints } from '../../../../../../shared/scripts/profile/ProfileEditAjaxEndPoints.ts';
import { setElementOnClick } from '../../../../../../shared/scripts/ui_utils/DomUtils.ts';
import { StorageWrapper } from '../../../../../../shared/scripts/StorageWrapper.ts';
import { MobileDeviceUtils } from '../../../../../../shared/scripts/MobileDeviceUtils.ts';
import { UIDeviceController } from '../../../../../../shared/scripts/ui_html/UIDeviceController.ts';
import { UIMMenuGameOrientationController } from '../../header/UIMMenuGameOrientationController.ts';
export class UIMProfileSettingsController extends UIProfileSettingsController {
    constructor(){
        super();
        this.editProfileButton = document.getElementById('m-edit-profile');
        setElementOnClick(this.editProfileButton, ()=>{
            showPlayerEditProfileDialog({
                selectColorAction: async (color)=>await ProfileEditAjaxEndPoints.updatePreferredColor(color)
            });
        });
        const deviceInfoButton = document.getElementById('m-debug-info');
        if (deviceInfoButton) {
            setElementOnClick(deviceInfoButton, ()=>{
                const isMobileWebBrowser = UIDeviceController.isUserOnMobileWebBrowser();
                var _MobileDeviceUtils_getBuildNumber, _MobileDeviceUtils_getPlatform, _MobileDeviceUtils_getStatusBarHeight, _MobileDeviceUtils_getSafeAreaInsetBottom;
                showDeviceInfoDialog({
                    width: document.body.clientWidth,
                    height: document.body.clientHeight,
                    userAgent: navigator.userAgent,
                    buildNumber: isMobileWebBrowser ? undefined : (_MobileDeviceUtils_getBuildNumber = MobileDeviceUtils.getBuildNumber()) !== null && _MobileDeviceUtils_getBuildNumber !== void 0 ? _MobileDeviceUtils_getBuildNumber : undefined,
                    portraitMode: StorageWrapper.isPortraitGamePlayEnabled(),
                    platform: isMobileWebBrowser ? undefined : (_MobileDeviceUtils_getPlatform = MobileDeviceUtils.getPlatform()) !== null && _MobileDeviceUtils_getPlatform !== void 0 ? _MobileDeviceUtils_getPlatform : undefined,
                    statusBarHeight: (_MobileDeviceUtils_getStatusBarHeight = MobileDeviceUtils.getStatusBarHeight()) !== null && _MobileDeviceUtils_getStatusBarHeight !== void 0 ? _MobileDeviceUtils_getStatusBarHeight : undefined,
                    safeAreaInsetBottom: (_MobileDeviceUtils_getSafeAreaInsetBottom = MobileDeviceUtils.getSafeAreaInsetBottom()) !== null && _MobileDeviceUtils_getSafeAreaInsetBottom !== void 0 ? _MobileDeviceUtils_getSafeAreaInsetBottom : undefined
                });
            });
        }
        new UIMMenuGameOrientationController();
    }
}
